import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { PUSH_PAYMENTS } from '../apiUrls';

const mutationRemoveNotifRule = (onSuccess, onError) => {
    return {
        mutationFn: (pushPaymentNotifRuleId) => {
            return client.delete(replaceParameters(PUSH_PAYMENTS.NOTIF_RULES.DELETE_RULE.url, { pushPaymentNotifRuleId: pushPaymentNotifRuleId }));
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationRemoveNotifRule;